import {Expose, Type} from 'class-transformer';
import {BasicData} from "../basic/BasicData";

export class DataEntry extends BasicData {

    static readonly  ModelFeatureAttribute = {
        CLASS_NAME: 'Data Entry'
    }

    @Expose()
    @Type(() => Number)
    id: string = '';

    @Expose()
    type: string = '';

    @Expose()
    started_at: string = '';

    @Expose()
    finished_at: string = '';

    @Expose()
    unit: string = '';
    
    @Expose()
    local_unit: string = '';

    @Expose()
    weapon_type: string = '';

    @Expose()
    caliber: string = '';
    
    @Expose()
    mgrs_coordinates: string = '';

    @Expose()
    coordinates: number[] = []

    @Expose()
    direction: string = '';
    
    @Expose()
    azimuth: string = '';

    @Expose()
    target_type: string = '';

    @Expose()
    target_quantity: string = '';

    @Expose()
    result: string = '';

    @Expose()
    @Type(() => Boolean)
    verified: boolean = false;

}
